import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Table,
} from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import { POST } from "../../../utils/apicalls";
import { API } from "../../../config/api";
import PageHeader from "../../pageHeader/pageheader";

function TelecallerIndex() {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [data, setData] = useState<any>();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(2000);
  const [meta, setMeta] = useState<any>({});
  const [selectdata, setselectData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const columns = [
    {
      dataIndex: "type",
      title: "type",
    },
    {
      dataIndex: "enquery_name",
      title: "enquery_name",
    },
    {
      dataIndex: "date",
      title: "date",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "feedback",
      title: "feedback",
    },
    {
      dataIndex: "employeeId",
      title: "employeeId",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "enquery_phone",
      title: "enquery_phone",
    },
    {
      dataIndex: "wrokUpdate",
      title: "wrokUpdate",

      render: (wrokUpdate: any) => {
        let color = "";
        switch (wrokUpdate?.toLowerCase()) {
          case "completed":
            color = "green";
            break;
          case "inprogress":
            color = "blue";
            break;
          case "pending":
            color = "red";
            break;
          default:
            color = "black"; // Default color for other statuses
        }
        return <span style={{ color }}>{wrokUpdate}</span>;
      },
    },
  ];

  const showModal = () => {
    setIsModalOpen(true); // Open the modal
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const filterEmployee = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        type: "telecaller",
        status: true,
      };
      const url = API.FILTER_EMPLOYEE;
      const response: any = await POST(url, obj);
      setselectData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    filterEmployee(); // Fetch data when the component mounts
  }, []);

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        projectId: values.projectId,
        telecallerId: values.telecallerId,
        type: values.type,
        enquery_name: values.enquery_name,
        date: values.date,
        feedback: values.feedback,
        employeeId: values.employeeId,
        client_id: values.client_id,
        enquery_phone: values.enquery_phone,
        altPhone: values.altPhone,
        wrokUpdate: values.wrokUpdate,
      };

      setIsLoading(true);
      const api = API.CREATE_TELECALLER;
      const postRequest: any = await POST(api, obj);
      if (postRequest.status) {
        notification.success({ message: "Telecaller created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
        fetchTelecallerWork(page);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTelecallerWork = async (page: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: pageSize,
        employeeId: form.getFieldValue("employeeId"),
      };
      const url = API.LIST_TELECALLER;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTelecallerWork(page);
  }, [page, pageSize]);

  const search = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 10,
        employeeId: values.employeeId,
      };
      const url = API.LIST_TELECALLER;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <PageHeader>
        <Row
          gutter={16}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Col>
            {" "}
            <Button
              type="primary"
              onClick={showModal}
              style={{ marginRight: "10px" }}
            >
              Create Telecaller wrok Details
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div>
        <Card>
          {" "}
          <Form form={form} onFinish={search} layout="vertical">
            {" "}
            <Row gutter={16}>
              {" "}
              <Col sm={6}>
                {selectdata && (
                  <Form.Item
                    label="Employee Name"
                    name="employeeId"
                    style={{ marginBottom: 10 }}
                  >
                    <Select
                      placeholder="Select an employee"
                      size="large"
                      allowClear
                    >
                      {selectdata?.map((users: any, i: any) => (
                        <Select.Option
                          key={users?.id}
                          value={Number(users?.id)}
                        >
                          {users?.fullName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>

      <Modal
        title="Create Telecaller Details"
        visible={isModalOpen}
        onCancel={handleCancel}
        width={1000}
        footer={false}
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="projectId"
                label=" projectId"
                rules={[{ required: true, message: "Enter projectId" }]}
              >
                <Input placeholder=" projectId" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="projectType"
                label="projectType"
                rules={[{ required: true, message: "Enter projectType" }]}
              >
                <Input placeholder="projectType" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="telecallerId"
                label="telecallerId"
                rules={[{ required: true, message: "Enter telecallerId" }]}
              >
                <Input placeholder="telecallerId" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="date"
                label="date"
                rules={[{ required: true, message: "Select startDate" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="feedback"
                label="feedback"
                rules={[{ required: true, message: "Enter feedback" }]}
              >
                <Input.TextArea placeholder="feedback" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item name="type" label="type">
                <Input placeholder="type" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              {selectdata && (
                <Form.Item
                  label="Employee Name"
                  name="employeeId"
                  style={{ marginBottom: 10 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Select an employee" size="large">
                    {selectdata?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.fullName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>

            <Col sm={6}>
              <Form.Item name="enquery_name" label="enquery_name">
                <Input placeholder="enquery_name" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="client_id" label="client_id">
                <Input placeholder="client_id" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="enquery_phone" label="enquery_phone">
                <Input placeholder="enquery_phone" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="altPhone" label="altPhone">
                <Input placeholder="altPhone" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="wrokUpdate"
                label="Work Update"
                rules={[
                  { required: true, message: "Please select a wrokUpdate!" },
                ]}
              >
                <Select placeholder="Select wrokUpdate">
                  <Select.Option value="pending">Pending</Select.Option>
                  <Select.Option value="inProgress">In Progress</Select.Option>
                  <Select.Option value="completed">Completed</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Create telecaller details
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Card>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: page, // Current page number
            pageSize: pageSize, // Rows per page
            total: meta?.total, // Total number of records
            showSizeChanger: true, // Allows user to change the number of rows per page
            pageSizeOptions: ["2", "10", "20", "50"], // Options for page size
            onChange: (pageNumber, pageSize) => {
              setPage(pageNumber); // Update current page
              setPageSize(pageSize); // Update page size
            },
          }}
        />
      </Card>
    </div>
  );
}

export default TelecallerIndex;
